<script>
import {defineComponent} from 'vue'
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import http from "@/http";

export default defineComponent({
  name: "RoadPricesView",
  data() {
    return {
      loading: false,
      dataList: [],
      totalElements: 0,
      totalPages: null,
      size: 15,
      page: 1,
      boards: [],
      form: {
        board_id: null,
      },
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/road-prices/excel`,
      uploadHeader: {Authorization: `${this.$store.state.accessToken}`},

      rules: {
        board_id: [
          {
            required: true,
            message: "Tashabbuslar doskasini tanlang!",
            trigger: "change",
          },
        ],
      },
    }
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    }
  },
  methods: {
    getBoards() {
      this.loading = true;
      http({url: `api/v1/boards`, params: {status: 1}})
          .then(({data}) => {
            this.boards = data.boards;
            this.form.board_id = data.boards[0].id;
            this.getRoadPrices()
          })
          .catch((err) => {
            ElMessage.error(
                err.response.data.message || `Hatolik qayta urinib ko'ring`
            );
          })
          .finally(() => {
            this.loading = false;
          });
    },
    handleSizeChange(val) {
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, size: val},
          })
          .then(() => {
            this.getRoadPrices();
          })
          .catch(() => {
          });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          })
          .then(() => {
            this.getRoadPrices();
          })
          .catch(() => {
          });
    },
    onClickDelete(id) {
      ElMessageBox.confirm("Ma'lumoitni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`/api/v1/road-prices/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Muvaffaqqiyatli o'chirildi",
                  });
                  this.getRoadPrices();
                })
                .catch(() => {
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },
    onChangeBoard() {
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, page: this.page},
          })
          .then(() => {
            this.getRoadPrices();
          })
          .catch(() => {
          });
    },
    getRoadPrices() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size
          ? parseInt(this.$route.query.size || "")
          : this.size;

      this.$http
          .get(`api/v1/road-prices`, {
            params: {
              board_id: this.form.board_id,
              limit: this.size,
              offset: (this.page - 1) * this.size,
            },
          })
          .then(({data}) => {
            this.dataList = data.data;
            this.totalElements = data.count;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    downloadExcel() {
      this.loading = true;
      this.$http
          .get(`api/v1/road-prices/excel`, {
            responseType: "blob",
            params: {
              board_id: this.form.board_id,
            },
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    indexMethod(index) {
      return index + (this.currentPage - 1) * this.size + 1
    },

    onBeforeUpload() {
      return this.$refs.formRef.validate((valid) => {
        this.loading = valid;
        return valid;
      });
    },
    onExceed(files) {
      console.log("exceeds", files);
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({name: "Auth"});
      }
      ElNotification({
        title: "Xatolik",
        message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
        type: "error",
      });
      this.loading = false;
    },
    onSuccessUpload() {
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
    },
  },
  mounted() {
    this.getBoards();
  }
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
        <el-select
            v-model="form.board_id"
            placeholder="Boardni tanlang"
            @change="onChangeBoard"
            clearable
            style="width: 280px">
          <el-option
              v-for="board in boards"
              :key="board.id"
              :value="board.id"
              :label="
                board.title +
                ' ' +
                board.season +
                '-' +
                'mavsum ' +
                board.year +
                ' yil'
              "
          />
        </el-select>
      </div>
      <div style="display: flex;gap:5px">
        <el-button
            class="upload-demo"
            type="warning"
            @click="downloadExcel"
        >
          <img
              style="margin-right: 5px;"
              alt=""
              src="@/assets/images/icons/download.svg"
          />
          Yuklash
        </el-button>
        <el-form
            v-if="form.board_id"
            label-position="top"
            style="height: 40px"
            :model="form"
            :rules="rules"
            ref="formRef"
        >
          <div style="display: flex; align-items: center; justify-content: right">
            <el-form-item prop="file">
              <el-upload
                  ref="uploadRef"
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="uploadHeader"
                  :data="form"
                  :multiple="false"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  :limit="1"
                  :on-exceed="onExceed"
                  :before-upload="onBeforeUpload"
                  :on-success="onSuccessUpload"
                  :on-error="onErrorUpload"
              >
                <template #trigger>
                  <el-button style="width: 100%" type="primary">
                    Excel fayldan yangilash
                  </el-button>
                </template>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>
        <router-link to="road-price/add" class="el-button el-button--primary">
          Qo'shish
        </router-link>
      </div>
    </div>
    <el-table
        :data="dataList"
        class="table"
        border
        height="calc(100vh - 235px)"
    >
      <el-table-column type="index" :index="indexMethod" width="80" label="#"/>
      <el-table-column prop="district" min-width="190" label="Tuman"/>
      <el-table-column prop="price" label="Yo'l narxi" min-width="180">
        <template v-slot="scope">
          {{ scope.row.price?.toLocaleString('ru-RU') }} UZS
        </template>
      </el-table-column>
      <el-table-column prop="half_ready_price" label="Yarim tayyor yo'l narxi" min-width="180">
        <template v-slot="scope">
          {{ scope.row.half_ready_price?.toLocaleString('ru-RU') || 0 }} UZS
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="" width="200" align="center">
        <template #default="scope">
          <el-button
              type="primary"
              size="small"
              @click="
              $router.push({
                name: 'RoadPriceFormEdit',
                params: { id: scope.row.id },
              })
            "
          >Tahrirlash
          </el-button>
          <el-button
              type="danger"
              size="small"
              @click="onClickDelete(scope.row.id)"
          >O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span>Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
              :page-sizes="[15, 20, 30, 50, 100, 200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  .actions {
  }
}

.el-button--primary {
  text-decoration: none;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.pagination-wrapper > span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>
